import { makeStyles } from '@material-ui/core/styles';
export var useSimpleFormIteratorStyles = makeStyles(function (theme) {
  var _a, _b;

  return {
    root: {
      padding: 0,
      marginBottom: 0,
      '& > li:last-child': {
        borderBottom: 'none'
      }
    },
    line: (_a = {
      display: 'flex',
      listStyleType: 'none',
      borderBottom: "solid 1px " + theme.palette.divider
    }, _a[theme.breakpoints.down('xs')] = {
      display: 'block'
    }, _a['&.fade-enter'] = {
      opacity: 0.01,
      transform: 'translateX(100vw)'
    }, _a['&.fade-enter-active'] = {
      opacity: 1,
      transform: 'translateX(0)',
      transition: 'all 500ms ease-in'
    }, _a['&.fade-exit'] = {
      opacity: 1,
      transform: 'translateX(0)'
    }, _a['&.fade-exit-active'] = {
      opacity: 0.01,
      transform: 'translateX(100vw)',
      transition: 'all 500ms ease-in'
    }, _a),
    index: (_b = {}, _b[theme.breakpoints.down('sm')] = {
      display: 'none'
    }, _b.marginRight = theme.spacing(1), _b),
    indexContainer: {
      display: 'flex',
      paddingTop: '1em',
      marginRight: theme.spacing(1),
      alignItems: 'center'
    },
    form: {
      flex: 2
    },
    action: {
      paddingTop: '0.5em'
    },
    leftIcon: {
      marginRight: theme.spacing(1)
    }
  };
}, {
  name: 'RaSimpleFormIterator'
});